import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Grid,
  Button,
  Modal,
} from '../../../../components/index';
import {
  validateObject,
  // validarCNPJ,
  trataMensagensErro,
} from '../../../../utils/requests';
import validarCNPJ from '../../../../utils/validator/cnpjValidator';
import { situacaoOrgaoVinculado } from '../../../../utils/listsSelect';
import Masks from '../../../../utils/masks';

class OrgaoVinculado extends Component {
  static getDerivedStateFromProps(props, state) {
    const { validadeCampos } = { ...state };
    if (props.orgaoVinculado && !state.didProps) {
      if (props.errosOrgaoVinculado) {
        props.errosOrgaoVinculado.forEach((item) => {
          validadeCampos[item.atributo] = false;
        });
        return ({
          orgaoVinculado: { ...props.orgaoVinculado },
          validadeCampos,
          errosOrgaoVinculado: props.errosOrgaoVinculado,
          touched: true,
          didProps: true,
        });
      }
      return ({ orgaoVinculado: { ...props.orgaoVinculado }, touched: true, didProps: true });
    }
    return null;
  }

  constructor(props) {
    super();
    const state = this.getInitialState();
    if (props.orgaoVinculado) {
      const { validadeCampos } = { ...state };
      Object.keys(validadeCampos).forEach((key) => {
        validadeCampos[key] = true;
      });
      state.validadeCampos = validadeCampos;
    }
    this.state = state;
  }

  getInitialState = () => {
    const initialState = {
      orgaoVinculado: {
        cnpj: null,
        idParticipante: null,
        nomeOrgaoVinculado: null,
        situacao: null,
      },
      touched: false,
      validadeCampos: {
        cnpj: false,
        nomeOrgaoVinculado: false,
        situacao: true,
      },
      didUpdate: false,
      didProps: false,
      errosOrgaoVinculado: null,
      estadoFormulario: 'inicial',
    };
    return initialState;
  }

  formularioProntoParaEnvio = () => (
    validateObject(this.state.validadeCampos)
  )

  resetState = () => {
    this.setState(this.getInitialState());
    this.props.onHide();
    this.props.resetOrgaoVinculado();
  }

  validarCnpjOrgaoVinculado = cnpj => (
    validarCNPJ(cnpj)
  )

  handleButton = () => {
    const cnpjValido = this.validarCnpjOrgaoVinculado(this.state.orgaoVinculado.cnpj);
    if (cnpjValido === false) {
      trataMensagensErro(['CNPJ Inválido. Informe um CNPJ válido.']);
    } else {
      const touched = true;
      this.setState({ ...this.state, touched }, this.handleEnviar);
    }
  }

  handleEnviar = () => {
    this.props.addOrgaoVinculado(
      this.state.orgaoVinculado,
      this.props.orgaoVinculado,
    );

    if (this.state.errosOrgaoVinculado) {
      this.props.validacaoErrosOrgaoVinculado(this.state.errosOrgaoVinculado);
    }
    this.resetState();
  }

  handleChange = (changeObj, name) => {
    const { acao } = { ...this.props };
    let { estadoFormulario } = { ...this.state };

    if (acao === 'novo' && this.state.errosOrgaoVinculado && this.state.errosOrgaoVinculado.length >= 1) {
      estadoFormulario = 'alterado';
    }
    let valor = changeObj.value;
    if (name === 'nomeOrgaoVinculado') {
      if (changeObj.value) {
        valor = changeObj.value.toUpperCase();
      }
    }
    this.setState({
      orgaoVinculado: {
        ...this.state.orgaoVinculado,
        [name]: valor,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
      estadoFormulario,
    });
  }

  // Para cada Input, sinalizar as acoes em que o mesmo pode ser alterado
  desabilitaInput = listaAcoesEditaveis => (
    // if (this.props.consulta) {
    //   return true;
    // }
    !listaAcoesEditaveis.includes(this.props.acaoModal)
  )

  // Escolhe o titulo do modal baseado na acao
  determinaTitulo = () => {
    let titulo;
    switch (this.props.acaoModal) {
      case 'edicao': titulo = 'Edição de Orgão Vinculado';
        break;
      default: titulo = 'Inclusão de Orgão Vinculado';
    }
    return titulo;
  }

  render() {
    const modalContent = (
      <React.Fragment>
        <div className="row" style={{ height: '370px', 'overflow-y': 'auto', 'overflow-x': 'hidden' }}>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled={this.state.orgaoVinculado.idParticipante != null
                  && this.desabilitaInput(['criacao'])}
                error={!this.state.validadeCampos.cnpj}
                // integer
                label="CNPJ"
                mask={Masks.cnpj}
                onChange={e => this.handleChange(e, 'cnpj')}
                required
                showMask
                touched={this.state.touched}
                value={this.state.orgaoVinculado.cnpj}
              />
            </Grid>
            <Grid cols="12 12 12 12">
              <Input
                // disabled={this.desabilitaInput(['criacao'])}
                label="Nome"
                maxLength="100"
                error={!this.state.validadeCampos.nomeOrgaoVinculado}
                value={this.state.orgaoVinculado.nomeOrgaoVinculado}
                onChange={e => this.handleChange(e, 'nomeOrgaoVinculado')}
                touched={this.state.touched}
                required
              />
            </Grid>
            <Grid cols="4 4 4 4">
              {this.props.acaoModal !== 'criacao' ?
                <Input
                  // disabled={this.desabilitaInput(['criacao', 'edicao'])}
                  label="Situação"
                  error={!this.state.validadeCampos.situacao}
                  value={this.state.orgaoVinculado.situacao}
                  number
                  itemList={situacaoOrgaoVinculado}
                  onChange={e => this.handleChange(e, 'situacao')}
                  touched={this.state.touched}
                  placeholder="Selecione a situação"
                  custom
                />
              : ''}
            </Grid>
          </div>
        </div>
      </React.Fragment>
    );
    const modalFooter = (
      <React.Fragment>
        <div className="right">
          <Button
            title="Desfazer"
            onClick={this.resetState}
            hint="Desfazer"
          />
          <Button
            className="dtp-primary"
            disabled={!this.formularioProntoParaEnvio()}
            title={this.props.orgaoVinculado ? 'Confirmar' : 'Adicionar'}
            onClick={(this.handleButton)}
            hint={this.props.orgaoVinculado ? 'Confirmar Operação' : 'Adicionar orgão Vinculado'}
          />
        </div>
      </React.Fragment>
    );
    return (
      <Modal
        {...this.props}
        conteudomodal={modalContent}
        conteudofooter={modalFooter}
        onHide={this.resetState}
        showTitle
        size="lg"
        title={this.determinaTitulo()}
      />
    );
  }
}

OrgaoVinculado.propTypes = {
  acaoModal: PropTypes.oneOf(['criacao', 'edicao']),
  onHide: PropTypes.func,
  consulta: PropTypes.bool,
}.isRequired;

export default OrgaoVinculado;



// WEBPACK FOOTER //
// ./src/pages/cadastros/EntesFederativos/Rpps/OrgaoVinculado.jsx